import "core-js/modules/es.array.push.js";
import NavbarToggleButton from "@/components/NavbarToggleButton";
import MobMenu from "@/components/SidebarPlugin/MobMenu";
// import Popper from "@/component/Popper.vue";
import { removeHubspot, getWelcomeDashCurrentClass, getStepDisable, goToPage } from "@/common/functions";
import { ref } from "vue";
export default {
  setup() {
    const popNoti = ref(null);
    return {
      popNoti
    };
  },
  data() {
    return {
      showPopNoti: false,
      active: false,
      mobileMenu: false,
      userCardShow: false,
      showSidebarr: false,
      username: localStorage.getItem("username"),
      profilePicUrl: localStorage.getItem("profilePicUrl"),
      showProfilePic: localStorage.getItem("showProfilePic"),
      clientName: localStorage.getItem("clientName"),
      clientRole: localStorage.getItem("client_role"),
      permission: parseInt(localStorage.getItem("permission")),
      loginData: JSON.parse(localStorage.getItem("login_data")),
      allowTransaction: parseInt(localStorage.getItem("allowTransaction"))
    };
  },
  computed: {
    getContainer() {
      return this.$el.querySelector("#popNoti");
    },
    isWelcomeDashboard() {
      return localStorage.getItem("isWelcomeDashboard");
    },
    welcomeDashboardItems() {
      return localStorage.getItem("welcomeDashboardItems") ? JSON.parse(localStorage.getItem("welcomeDashboardItems")) : [];
    },
    getProgress() {
      return parseInt(this.stageCompleted) / 4 * 100;
    },
    getPending() {
      return 4 - parseInt(this.stageCompleted);
    },
    getCurrentClass() {
      return getWelcomeDashCurrentClass(this.welcomeDashboardItems);
    },
    stageCompleted() {
      var completed = 0;
      if (this.welcomeDashboardItems) {
        Object.entries(this.welcomeDashboardItems).forEach(([, value]) => {
          if (value === 2) {
            completed = completed + 1;
          }
        });
      }
      return completed;
    }
  },
  name: "sideBar",
  components: {
    NavbarToggleButton,
    MobMenu
    // Popper,
  },
  props: {
    autoClose: {
      type: Boolean,
      default: true,
      description: "Whether sidebar should autoclose on mobile when clicking an item"
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    getStepDisableClass(module) {
      return getStepDisable(module, this.welcomeDashboardItems);
    },
    goTo(module) {
      goToPage(this, module, this.welcomeDashboardItems);
    },
    closeSidebar() {
      this.$showSidebarr = false;
    },
    showSidebar() {
      this.$showSidebarr = true;
    },
    logout() {
      if (window.Sentry) {
        window.Sentry.setUser(null);
      }
      var vm = this;
      localStorage.removeItem("login_data");
      localStorage.removeItem("isWelcomeDashboard");
      localStorage.removeItem("welcomeDashboardItems");
      removeHubspot(vm);
      localStorage.removeItem("clientName");
      localStorage.removeItem("expired_time");
      this.$router.push({
        path: "/login"
      });
    },
    getFirstLetter(val) {
      if (!val) {
        return "";
      }
      return val.charAt(0).toUpperCase();
    }
  },
  beforeUnmount() {
    if (this.$showSidebarr) {
      this.$showSidebarr = false;
    }
  },
  emits: ["click"]
};